/**
 * Standalone notification utility for use outside Vue components (e.g. Vuex stores).
 * The `notify` function is set up during app initialization in main.js by calling `setNotify`.
 */

let _notify = null;

export function setNotify(fn) {
	_notify = fn;
}

export function notify(...args) {
	if (_notify) {
		return _notify(...args);
	}

	console.warn('[notify] Notification plugin not yet initialized.');
}

notify.close = function close(id) {
	if (_notify && typeof _notify.close === 'function') {
		return _notify.close(id);
	}

	console.warn('[notify] Notification plugin not yet initialized.');
};
